import React from "react";
import Helmet from "react-helmet";
import { connect } from "react-redux";

import { Container, Row, Col } from "reactstrap";

import { Form } from "./Form";

class Add extends React.Component {
  constructor() {
    super();
  }

  redirect(to) {
    const { router } = this.context;
    // so that folks can unit test w/o hassle
    if (router) router.transitionTo(to);
  }

  render() {
    const { apiHost } = this.props;

    return (
      <div className="panel panel-default panel-border-color panel-border-color-primary">
        <div className="panel-heading panel-heading-divider">
          Dodaj artykuł
          <div className="tools">{/*<i className="fa fa-plus" />*/}</div>
          <span className="panel-subtitle" />
        </div>

        <div className="panel-body">
          <Form />
        </div>
      </div>
    );
  }
}

Add.contextTypes = {
  router: React.PropTypes.object.isRequired
};

export default connect(
  state => ({
    apiHost: state.config.apiHost
  }),
  {}
)(Add);



// WEBPACK FOOTER //
// ./src/browser/article/Add.js